import React from 'react';
import { 
  TrendingUp, 
  Truck, 
  Package, 
  Factory, 
  Settings, 
  DollarSign, 
  Calculator, 
  Leaf, 
  Building2 
} from 'lucide-react';

const functions = [
  {
    id: 1,
    icon: TrendingUp,
    title: 'Trade Execution',
    description: 'Real-time visibility into trade flows, risks, and exceptions.'
  },
  {
    id: 2,
    icon: Truck,
    title: 'Logistics',
    description: 'End-to-end shipment tracking and carrier intelligence.'
  },
  {
    id: 3,
    icon: Package,
    title: 'Inventory',
    description: 'Unified stock visibility across locations and channels.'
  },
  {
    id: 4,
    icon: Factory,
    title: 'Processing',
    description: 'Production workflow monitoring and throughput analytics.'
  },
  {
    id: 5,
    icon: Settings,
    title: 'Operations',
    description: 'Cross-functional operational intelligence and coordination.'
  },
  {
    id: 6,
    icon: DollarSign,
    title: 'Finance',
    description: 'Financial data integration and cash flow visibility.'
  },
  {
    id: 7,
    icon: Calculator,
    title: 'Accounting',
    description: 'Automated reconciliation and financial reporting.'
  },
  {
    id: 8,
    icon: Leaf,
    title: 'Sustainability',
    description: 'ESG metrics tracking and sustainability reporting.'
  },
  {
    id: 9,
    icon: Building2,
    title: 'Neobank Services',
    description: 'Integrated payments, FX, and financing solutions.'
  }
];

const EnterpriseFunctions = () => {
  return (
    <section id="solutions" className="relative py-24 lg:py-32 bg-white dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 dark:text-white">
            Intelligence across every enterprise function
          </h2>
        </div>

        {/* Functions Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {functions.map((func) => {
            const Icon = func.icon;
            return (
              <div
                key={func.id}
                className="group p-6 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 hover:border-slate-200 dark:hover:border-slate-700 transition-all duration-300"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 text-slate-600 dark:text-slate-400 group-hover:text-orange-500 transition-colors" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-slate-900 dark:text-white mb-1">
                      {func.title}
                    </h3>
                    <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                      {func.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Intelligence Layer Statement */}
        <div className="mt-16 pt-16 border-t border-slate-200 dark:border-slate-800">
          <p className="text-center text-slate-600 dark:text-slate-400 max-w-3xl mx-auto">
            TradeEngine.AI acts as an intelligence layer across existing enterprise systems — 
            unifying data, surfacing insights, and enabling smarter decisions without replacing 
            your current infrastructure.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseFunctions;
